const pvzByIds = {};
let pvzSelected = null;

const addPvzInfo = (id, info) => {
    if (pvzByIds[id]) {
        return;
    }
    pvzByIds[id] = info;
}

const getPvzById = async (id) => {
    if (!pvzByIds[id]) {
        await loadPvzs([id]);
    }
    return pvzByIds[id] ?? {};
};

const getMapCoords = async () => {
    const apiResult = await fetch(`/api/city/current/`);
    if (apiResult.status !== 200) {
        // default Moscow, but maybe we should return error code
        return { lat: 55.752491072272264, long: 37.61567497253408, zoom: 11 };
    }
    return await apiResult.json();
};

const loadPvzs = async (pvzIdList = []) => {
    const apiResult = await fetch(`/api/pvzs/?ids=${pvzIdList.join()}`);
    if (apiResult.status !== 200) {
        // don't add anything if request fails
        return;
    }
    const data = await apiResult.json();
    Object.values(data).forEach((pvz) => {
        const { id } = pvz;
        addPvzInfo(id, pvz);
    });
};

const getMapData = async (pvzIdList = []) => {
    const apiResult = await fetch(`/api/pvzs/map/?ids=${pvzIdList.join()}&type=product`);
    if (apiResult.status !== 200) {
        return [];
    }
    return await apiResult.json();
};

const getAvailableInfo = async () => {
    const apiResult = await fetch(`/api/pvzs/available/?id=${window.itemId}`);
    if (apiResult.status !== 200) {
        return [];
    }
    return await apiResult.json();
};

const getPvzDate = (dateString, type) => {
    if (!dateString) {
        return '<ymaps class="acm-status ymaps-info ymaps-status _error">Получение недоступно</ymaps>';
    }
    const date = moment(dateString, 'DD.MM.YYYY');
    const startOfToday = moment().startOf('day');
    const startOfTomorrow = moment().add(1, 'days').startOf('day');
    if (date.isSame(startOfToday) && type === 'posmachine') {
        return '<ymaps class="acm-status ymaps-info ymaps-status _green">Забрать сейчас</ymaps>';
    }
    if (date.isSame(startOfToday)) {
        const now = moment();
        const takeoutText = (now.hours() >= 9 && now.hours() < 21)
            ? 'Забрать сейчас'
            : 'Получить сегодня';
        return `<ymaps class="acm-status ymaps-info ymaps-status _green">${takeoutText}</ymaps>`;
    }
    const deliveryWord = type === 'posmachine' ? 'Доставим' : 'Получить';
    if (date.isSame(startOfTomorrow)) {
        return `<ymaps class="acm-status ymaps-info ymaps-status _yellow">${deliveryWord} завтра</ymaps>`;
    }
    const dayText = date.format('D MMMM');
    return `<ymaps class="acm-status ymaps-info ymaps-status _yellow">${deliveryWord} ${dayText}</ymaps>`;
};

const getPvzDateStandalone = (dateString, type) => {
    if (!dateString) {
        return `<span class="acm-status _error">Получение недоступно</span>`;
    }
    const date = moment(dateString, 'DD.MM.YYYY');
    const startOfToday = moment().startOf('day');
    const startOfTomorrow = moment().add(1, 'days').startOf('day');
    if (date.isSame(startOfToday) && type === 'posmachine') {
        return `<span class="acm-status _green">Забрать сейчас</span>`;
    }
    if (date.isSame(startOfToday)) {
        const now = moment();
        const takeoutText = (now.hours() >= 9 && now.hours() < 21)
            ? 'Забрать сейчас'
            : 'Получить сегодня';
        return `<span class="acm-status _green">${takeoutText}</span>`;
    }
    const deliveryWord = type === 'posmachine' ? 'Доставим' : 'Получить';
    if (date.isSame(date, startOfTomorrow)) {
        return `<span class="acm-status _yellow">${deliveryWord} завтра</span>`;
    }
    const dayText = date.format('D MMMM');
    return `<span class="acm-status _yellow">${deliveryWord} ${dayText}</span>`;
};

const getPvzIconClass = (id) => {
    if (id === pvzSelected) {
        return 'ymaps-red';
    }
    return 'ymaps-blue';
};

const getTemplateByPvz = (pvz) => {
    const pvzAvailableInfo = window.availableInfo[pvz.id];
    const caption = pvz.type === 'pvz' ? 'Пункт выдачи' : 'Постамат';
    const layout = window.ymaps.templateLayoutFactory.createClass(
        `
<ymaps class="ymaps-2-1-79-islets_dot-icon-with-caption">
  <ymaps class="ymaps-2-1-79-islets_dot-icon-with-caption__caption-block">
    <ymaps class="acm-status ymaps-info ymaps-name _yellow">${caption}</ymaps>
    ${getPvzDate(pvzAvailableInfo, pvz.type)}
  </ymaps>
  <ymaps>
    <ymaps class="ymaps-2-1-79-svg-icon ${getPvzIconClass(pvz.id)} ymaps-icon"></ymaps>
  </ymaps>
</ymaps>
      `,
        {
            build: function () {
                layout.superclass.build.call(this);
                const statusElements = this.getParentElement().getElementsByClassName('acm-status');
                const maxWidth = Math.max(...Array.from(statusElements).map((elem) => elem.offsetWidth));
                this.getData().options.set('shape', {
                    type: 'Rectangle',
                    coordinates: [
                        [0, -33],
                        [maxWidth, 0],
                    ],
                });
            },
        },
    );
    return layout;
};

// add autoload
document.addEventListener('DOMContentLoaded', async () => {
    const { map_latitude, map_longitude, map_zoom } = await getMapCoords();
    await loadPvzs(window.pvzNeeded ?? []);
    window.availableInfo = await getAvailableInfo();
    const pvzData = await getMapData(window.allPvzList ?? []);

    window.ymaps?.ready(function () {
        window.pvzMap = new window.ymaps.Map('all-pvz-map', {
            center: [map_latitude, map_longitude],
            zoom: map_zoom,
            controls: ['zoomControl', 'fullscreenControl']
        }, {
            searchControlProvider: 'yandex#search'
        });
        window.objectManager = new ymaps.ObjectManager({ clusterize: true, gridSize: 32, zoomMargin: [50, 150, 50, 50] });
        const features = pvzData.map((pvz) => (
            {
                type: 'Feature',
                id: pvz.id,
                geometry: {
                    type: 'Point',
                    coordinates: [pvz.map_latitude, pvz.map_longitude],
                },
                options: {
                    iconLayout: getTemplateByPvz(pvz),
                },
                properties: {
                    pvzType: pvz.type,
                    hintContent: `<strong>${pvz.name}</strong>`,
                },
            }
        ));
        window.objectManager.add(features);
        window.pvzMap.geoObjects.add(window.objectManager);
        window.pvzMap.setBounds(window.objectManager.getBounds(), { zoomMargin: [50, 150, 50, 50] });
        window.objectManager.objects.events.add('click', (e) => {
            const objectId = e.get('objectId');
            pvzSelected = objectId;
            window.updatePvzMap(objectId);
        });

        window.pvzMap.events.add('actionend', () => {
            const clusters = window.objectManager.clusters.getAll();
            clusters.forEach((cluster) => {
                const { properties: { geoObjects } } = cluster;
                const activeObjects = geoObjects.filter((object) => object.id === Number(pvzSelected));
                const availableObjects = geoObjects.filter((object) => window.availableInfo[object.id]);
                const [firstActiveObject] = Array.from(activeObjects);
                const activeAvailable = availableObjects.includes(firstActiveObject);
                const hasActive = activeObjects.length > 0;
                if (hasActive && activeAvailable) {
                    window.objectManager.clusters.setClusterOptions(cluster.id, { preset: 'islands#redClusterIcons' });
                    return;
                }
                if (hasActive) {
                    window.objectManager.clusters.setClusterOptions(cluster.id, { preset: 'islands#blackClusterIcons' });
                    return;
                }
                const hasAvailable = availableObjects.length > 0;
                if (!hasAvailable) {
                    window.objectManager.clusters.setClusterOptions(cluster.id, { preset: 'islands#grayClusterIcons' });
                    return;
                }
                window.objectManager.clusters.setClusterOptions(cluster.id, { preset: 'islands#blueClusterIcons' });
            });
        });

        window.pvzMap.behaviors.disable('scrollZoom');
        if(Math.max($(window).width(), window.innerWidth) < 750) {
            window.pvzMap.behaviors.disable('drag');
        }
    });
});

// почти модули, вместо export - глобальная переменная
window.updatePvzMap = async (pvzId, manager = window.objectManager) => {
    const pvzInfo = await getPvzById(pvzId);
    const state = manager.getObjectState(pvzId);
    if (!state.found) {
        return;
    }
    const pvzAvailableInfo = window.availableInfo[pvzId];
    const content = `
                <div class="acm-delivery-bottom">
                    <div class="acm-delivery-content">
                        <div>
                            <div class="acm-delivery-content__point">
                                <strong>
                                    ${pvzInfo.name},&nbsp;
                                </strong>
                                ${pvzInfo.address}
                            </div>
                            <p>${pvzInfo.comment}</p>
                            ${getPvzDateStandalone(pvzAvailableInfo, pvzInfo.type)}
                        </div>
                    </div>
                </div>
            `;
    const elem = document.querySelector('.pvz-target');
    if (elem) {
        elem.innerHTML = content;
    }
    const { objects } = manager;
    if (objects === null) {
        return;
    }
    objects.each(({ id, properties: { pvzType: type } }) => {
        objects.setObjectOptions(id, { iconLayout: getTemplateByPvz({ id, type }) });
    });
};
